import { aboutInfo } from '@/mocks/baoliao';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
            {aboutInfo.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-10">
            {aboutInfo.description}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {aboutInfo.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary-600 mb-2">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}